"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of competitor site.
 *
 * @author Radek Beran
 */


var CompetitorSiteConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorSiteConverter, _DataObjectConverter_);

  function CompetitorSiteConverter() {
    _classCallCheck(this, CompetitorSiteConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorSiteConverter).apply(this, arguments));
  }

  return CompetitorSiteConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorSiteConverter = CompetitorSiteConverter;